import * as styles from './Icon.module.scss';

import cn from 'classnames';
import React from 'react';
import Sprite from 'src/assets/images/icons.svg';

import { IconPropColor, IconPropView } from './config';

export type IconProps = {
  view: IconPropView;
  color?: IconPropColor;
  full?: boolean;
} & React.SVGProps<SVGSVGElement>;

const Icon: React.FC<IconProps> = ({ view, className, color, full, ...props }) => {
  return (
    <svg className={cn(styles.icon, color && styles[`icon_color_${color}`], full && styles.icon_full, className)} {...props}>
      <use href={`${Sprite}#${view}`} />
    </svg>
  );
};

export default React.memo(Icon);
